import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { AlertCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-20 px-4 bg-cream" data-id="element-124">
      <div className="max-w-4xl mx-auto" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-126">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-sage/10 rounded-full mb-6" data-id="element-127">
            <AlertCircleIcon className="w-10 h-10 text-sage" aria-hidden="true" data-id="element-128" />
          </div>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-charcoal mb-6" data-id="element-129">
            The Invisible Trigger
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="prose prose-lg md:prose-xl max-w-3xl mx-auto text-charcoal/80" data-id="element-130">
          <p className="leading-relaxed mb-6" data-id="element-131">
            Most sleep consultants tell you to focus on "schedules" or "wake
            windows." But schedules don't matter if your baby's brain thinks the
            crib is a life-threatening environment.
          </p>
          <p className="leading-relaxed mb-6" data-id="element-132">
            Every time you put your baby down, their{' '}
            <strong data-id="element-133">Vestibular System</strong> (inner ear) detects a change in
            gravity. To a newborn, "falling" means "danger." This triggers a
            cortisol spike that wipes out all the hard work you just did rocking
            them to sleep.
          </p>
          <p className="text-xl font-semibold text-sage leading-relaxed" data-id="element-134">
            Your baby isn't "clingy"—their survival alarm is just set too high.
          </p>
        </motion.div>
      </div>
    </section>;
}